import React, { FC, useEffect, useState, useContext,useRef } from 'react';
import { TasksDispatchContext, useTask } from '../stateManagement/context';
import { get, post } from "../fetchers/fetchers";
import { useParams } from "react-router";
import { getInvestigationAssessment, getInvestigations, getControlMeasureCosts, getTemplateGroups, getSeverities } from "../stateManagement/data";


import {
    ComponentTypeID,
    IAdequacy,
    IControlMeasure, IControlMeasureAssessment, IControlMeasureCost,
    IInvestigationAssessment,
    IControlType,
    IInvestigation
} from "../types/types";


import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    makeStyles,
    MenuItem,
    Select,
    TableCell,
    TableRow,
    TextField,
    Typography
} from "@material-ui/core";
import { CostAdequacy, order_of_mag } from "./control_measure_cost";
import ControlTypeSelection from "./control_type";
import Comments from "./comments";
import { LinkOff, TabUnselectedSharp } from '@material-ui/icons';
import { constants } from 'crypto';
import Investigations from './investigations';
import { API_URL } from "../env";
import InvestigationsCell from './investigationscell';


interface IReasonablyPracticableTestProps {
    additional: boolean
    control_measure: IControlMeasure
    //control_measure_cost: IControlMeasureCost
    comment_id: number
    control_types: IControlType[]
    adequacies: IAdequacy[]
    control_measure_assessment: IControlMeasureAssessment
    is_primary: boolean
    updateControlMeasureAssessment: (controlMeasureAssessment: IControlMeasureAssessment) => void;
    updateControlMeasure: (controlMeasure: IControlMeasure) => void;
}

interface IRouteParams {
    id: string
}

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 300,
        maxWidth: 400,
        whiteSpace: "normal",
        fontSize: 14,
    },
    menu: {
        width: 200,
        whiteSpace: "normal",
        fontSize: 14,
    },
    listItem: {
        whiteSpace: "normal",
        fontSize: 14,


    }
}));

const ReasonablyPracticableTest: FC<IReasonablyPracticableTestProps> = React.memo(({
    additional,
    control_measure,
    control_types,
    comment_id,
    control_measure_assessment,
    //control_measure_cost,
    adequacies,
    is_primary,
    updateControlMeasure,
    updateControlMeasureAssessment
}) => {


    const classes = useStyles();
    let tasks = useTask()
    let dispatch = useContext(TasksDispatchContext)
    const params = useParams<IRouteParams>()

    const [write_access, setWriteAccess] = useState<boolean>(false);

    const order_of_mag_level = (control_measure_cost: IControlMeasureCost): number => {
        const order_of_magnitute = [
            { limit: 1, label: "<1" },
            { limit: 2, label: "1-2" },
            { limit: 5, label: "2-5" },
            { limit: 10, label: "5-10" },
            { limit: 20, label: "10-20" },
            { limit: 50, label: "20-50" },
            { limit: 100, label: "50-100" },
            { limit: 1000, label: "> 100" },
        ]
        let cost = 0
        let op_before = 0
        let op_after = 0

        if (control_measure_cost.cost) {
            cost = control_measure_cost.cost
        }
        if (control_measure_cost.operating_cost_before) {
            op_before = control_measure_cost.operating_cost_before
        }
        if (control_measure_cost.operating_cost_after) {
            op_after = control_measure_cost.operating_cost_after
        }

        // NPV
        let years = 30
        let discount_rate = 0.07

        let NPV_op = 0
        for (let i = 0; i < years; i++) {
            let df = 1. / (1. + discount_rate) ** i
            NPV_op += df * (op_after - op_before)
        }

        let total_cost = cost + NPV_op

        let level = order_of_magnitute.length - 1
        for (let i = order_of_magnitute.length - 1; i > -1; i--) {
            if (total_cost / 1000000 > order_of_magnitute[i].limit) {
                break
            }
            level = i
        }
        return order_of_magnitute[level].limit
    }


    const [currentControlMeasureAssessment, setCurrentControlMeasureAssessment] = useState<IControlMeasureAssessment>(control_measure_assessment);
    const [currentControlMeasureCost, setCurrentControlMeasureCost] = useState<IControlMeasureCost>({
        control_measure_id: control_measure_assessment.control_measure_id
    });

    useEffect(() => {
        if (tasks.loaded) {
            const newControlMeasureCost = tasks.controlMeasureCosts.find(cma => 
                cma.control_measure_id === control_measure_assessment.control_measure_id
            );

            // Convert objects to JSON string for comparison
            const newCostString = JSON.stringify(newControlMeasureCost);
            const currentCostString = JSON.stringify(currentControlMeasureCost);

            if (newControlMeasureCost && newCostString  !== currentCostString) {
                setCurrentControlMeasureCost(newControlMeasureCost);
            }
        }
    }, [tasks.controlMeasureCosts, control_measure_assessment.control_measure_id]);
    




    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks.write_access])

    useEffect(() => {
        if (tasks.loaded) {
            if (currentControlMeasureAssessment.id !== undefined && control_measure_assessment.id !== undefined) {
                if (control_measure_assessment.id > currentControlMeasureAssessment.id) {
                    setCurrentControlMeasureAssessment(control_measure_assessment)
                }
            }

        }
    }, [tasks.loaded, currentControlMeasureAssessment, control_measure_assessment])

    const getControlTypeID = (control_measure: IControlMeasure) => {
        if (control_measure.control_type_id) {
            return control_measure.control_type_id.toString()
        }
        return ""
    }


    const setControlMeasureCost = async (controlMeasureCost: IControlMeasureCost) => {
        let c = { ...controlMeasureCost }

        delete c.id
        delete c.created_at

        await post<IControlMeasureCost>(API_URL + "control_measures/" + params.id.toString() + "/costs", c);
        getControlMeasureCosts(params.id, dispatch)
    }


    const updateControlMeasureCost = (controlMeasureCost: IControlMeasureCost) => {



        let c = { ...controlMeasureCost }

        delete c.id
        delete c.cssl
        delete c.df
        delete c.annualised_cost
        delete c.cost_adequacy
        delete c.cost_adequacy_id
        delete c.document

        setControlMeasureCost(c).then(() => {
        })

    };



    return (
        <>

            <TableRow>
                <TableCell>{control_measure.description}</TableCell>
                {is_primary && <TableCell>{control_types.find(ct => ct.id === control_measure.control_type_id)?.name}</TableCell>}

                {!is_primary && <TableCell style={{ position: "sticky", backgroundColor: "#FFFFFF" }}><ControlTypeSelection control_types={control_types}
                    initial_selection_id={getControlTypeID(control_measure)}
                    control_measure={control_measure}
                    updateControlMeasure={updateControlMeasure} /></TableCell>}

                <TableCell>
                    <Checkbox
                        checked={currentControlMeasureAssessment.de_minimis}
                        disabled={is_primary}
                        color="primary"
                        onChange={() => {
                            let c = { ...currentControlMeasureAssessment }
                            c.de_minimis = !currentControlMeasureAssessment.de_minimis
                            setCurrentControlMeasureAssessment(c)
                            updateControlMeasureAssessment(c)
                        }}
                    />
                </TableCell>
                <TableCell>
                    <Checkbox
                        checked={currentControlMeasureAssessment.good_practice}
                        disabled={is_primary}
                        color="primary"
                        onChange={() => {
                            let c = { ...currentControlMeasureAssessment }
                            c.good_practice = !currentControlMeasureAssessment.good_practice
                            setCurrentControlMeasureAssessment(c)
                            updateControlMeasureAssessment(c)
                        }}
                    />
                </TableCell>
                {is_primary && <TableCell
                    style={{ whiteSpace: "nowrap" }}>
                    {order_of_mag(currentControlMeasureCost)}
                </TableCell>}

                {!is_primary && <TableCell >
                    <Select

                        value={order_of_mag_level(currentControlMeasureCost)}
                        disabled={!write_access}
                        onChange={(event) => {
                            let value = parseInt(event.target.value as string)
                            // check if value is undefined

                            if (value !== undefined) {
                                let c = { ...currentControlMeasureCost }


                                c.cost = (value * 1000000) / 2 + 1
                                setCurrentControlMeasureCost(c)
                                updateControlMeasureCost({ ...c })

                            }
                        }}>
                        <MenuItem className={classes.listItem} value={1}>{"<1"}</MenuItem>
                        <MenuItem className={classes.listItem} value={2}>1-2</MenuItem>
                        <MenuItem className={classes.listItem} value={5}>2-5</MenuItem>
                        <MenuItem className={classes.listItem} value={10}>5-10</MenuItem>
                        <MenuItem className={classes.listItem} value={20}>10-20</MenuItem>
                        <MenuItem className={classes.listItem} value={50}>20-50</MenuItem>
                        <MenuItem className={classes.listItem} value={100}>50-100</MenuItem>
                        <MenuItem className={classes.listItem} value={1000}>{"> 100"}</MenuItem>
                    </Select>
                </TableCell>}

                {!additional && <TableCell style={{ textAlign: "center", whiteSpace: "nowrap" }}>

                    {CostAdequacy(currentControlMeasureCost)} <br />
                    ({(currentControlMeasureCost.df) ? (currentControlMeasureCost.df) > 25000 ? "> 25,000" : Number(currentControlMeasureCost.df.toFixed(0)).toLocaleString() : "-"})
                </TableCell>}

                <TableCell>
                    <FormControl className={classes.formControl} margin='dense'>
                        <Select
                            MenuProps={{ className: classes.menu }}
                            value={currentControlMeasureAssessment.overall_assessment_id}
                            disabled={!write_access}
                            onChange={(event) => {
                                let value = parseInt(event.target.value as string)
                                // check if value is undefined

                                if (value !== undefined) {
                                    let c = { ...currentControlMeasureAssessment }
                                    c.overall_assessment_id = value
                                    setCurrentControlMeasureAssessment(c)
                                    updateControlMeasureAssessment({ ...c })

                                }
                            }}>
                            <MenuItem className={classes.listItem} value={0}></MenuItem>
                            <MenuItem className={classes.listItem} value={1}>Reasonably Practicable</MenuItem>
                            <MenuItem className={classes.listItem} value={2}>Reasonably Practicable (tentative)</MenuItem>
                            <MenuItem className={classes.listItem} value={3}>Not Reasonably Practicable (tentative)</MenuItem>
                            <MenuItem className={classes.listItem} value={4}>Not Reasonably Practicable</MenuItem>
                            <MenuItem className={classes.listItem} value={5}>Cannot Determine at this Time</MenuItem>
                        </Select>
                    </FormControl>
                </TableCell>
                <TableCell>
                    <TextField
                        style={{ width: '100%' }}
                        inputProps={{ style: { fontSize: "11pt" } }}
                        id="standard-number"
                        multiline={true}
                        disabled={!write_access}
                        size={"small"}
                        value={currentControlMeasureAssessment.overall_justification}
                        InputLabelProps={{
                            shrink: true,

                        }}

                        InputProps={{
                            style: { fontSize: 14 },
                        }}
                        onChange={(event) => {
                            let v = event.target.value
                            let c = { ...control_measure_assessment }
                            c.overall_justification = v
                            setCurrentControlMeasureAssessment(c)
                        }}
                        onBlur={
                            (event) => {
                                let v = event.target.value
                                let c = { ...control_measure_assessment }
                                c.overall_justification = v
                                updateControlMeasureAssessment({ ...c })
                            }
                        } />
                </TableCell>
                <TableCell>
                    <InvestigationsCell writeAccess={write_access} elementUUID={control_measure.uuid} linkType={ComponentTypeID.AdditionalControlMeasuer} />
                </TableCell>
                <TableCell>
                    <TableCell>
                        {control_measure.uuid && <Comments parent_uuid={parseInt("" + comment_id + control_measure.uuid)} type_id={ComponentTypeID.ReasonablyPracticable} />}
                    </TableCell>
                </TableCell>






            </TableRow>
        </>
    );
})

export default ReasonablyPracticableTest;
